import TimingDiagram from './TimingDiagram'
export default TimingDiagram
